import { DAY, MINUTE, type TinyChat, type ChatListInput, type ChatListSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { chatListKey } from '../keys'
import { type GetHookResponse } from '../hooks'

export function useChats(): GetHookResponse<TinyChat[]> {
  return useTantalimQuery<ChatListInput, ChatListSuccess, TinyChat[]>({
    url: '/ai/chat/list',
    queryKey: chatListKey(),
    input: {},
    convertResponse: (data) => data.chats,
    options: {
      gcTime: DAY,
      staleTime: 15 * MINUTE,
    },
  })
}
